import styles from "./ReferralLinkInvite.module.scss";
import { useDispatch, useSelector } from "../../hooks";
import linkIcon from "./icons/link.png";
import { useEffect, useState } from "react";
import { getRefLink } from "../../utils/links";
import { InfoSnackbar } from "../InfoSnackbar/InfoSnackbar";
import { getInviteMessage } from "../../redux/referals/get-invite-message.handler";
import { Loader } from "../Loader/Loader";
import { ErrorSnackbar } from "../ErrorSnackbar/ErrorSnackbar";
import { now } from "../../utils/time";
import { useTracking } from "../../hooks/traking";
import { shareReferralInviteFlow, useReferralInviteTracking } from "../../platform/referral-invite";

export const ReferralLinkInvite = () => {
    const [refLink, setRefLink] = useState('');
    const [notify, setNotify] = useState(false);

    const dispatch = useDispatch();
    const userId = useSelector(store => store.user.info.id);
    const { inviteMessage, loading, error } = useSelector(store => store.referals);

    const { trackClick, trackCustom } = useTracking('ReferralLinkInvite');

    useReferralInviteTracking(trackCustom);

    useEffect(() => {
        setRefLink(getRefLink(userId));
    }, [userId]);

    const shareClickHandler = async () => {
        trackClick('call');

        const result = await shareReferralInviteFlow(refLink, getValidInviteMessage);
        if (result.outcome === "shared") {
            trackCustom('invited');
        } else if (result.outcome === "cancelled") {
            trackCustom('declined');
        } else if (result.outcome === "error") {
            trackCustom('error', { value: result.errorCode ?? "unknown" });
        }
    };

    const getValidInviteMessage = async (): Promise<string | null> => {
        const isExpired = !inviteMessage || inviteMessage.expirationDate <= now();

        if (!isExpired) {
            return inviteMessage.id;
        }

        const result = await dispatch(getInviteMessage());

        if (getInviteMessage.fulfilled.match(result)) {
            return result.payload.id;
        }

        return null;
    };

    const copyLinkHandler = async () => {
        await navigator.clipboard.writeText(refLink);
        setNotify(true);
    };

    return (
        <>
            <div className={styles.container}>
                <div className={styles.linkBlock} onClick={copyLinkHandler}>
                    <img src={linkIcon} alt="Реферальная ссылка" className={styles.icon} />
                    <span className={styles.link}>Реферальная ссылка</span>
                </div>

                {notify && (
                    <InfoSnackbar
                        infoMessage="Скопировано в буфер обмена"
                        onCloseHandler={() => setNotify(false)}
                    />
                )}

                <button className={styles.inviteButton} onClick={shareClickHandler}>
                    Пригласить друга
                </button>
            </div>

            {loading && <Loader />}
            {!!error && <ErrorSnackbar errorMessage={error} />}
        </>
    );
};
